
import { defineComponent, toRaw } from 'vue'
import { loadStripe } from '@stripe/stripe-js/pure'
export default defineComponent({
  props: {
    location: {
      type: Object,
    },
    stripeCardError: {
      type: String,
    },
  },
  async mounted() {
    await this.configureStripe()
  },
  methods: {
    async configureStripe() {
      const { stripe: publishableKey, stripeAccountId } = toRaw(this.location)
      const stripe = await loadStripe(publishableKey, {
        stripeAccount: stripeAccountId,
      })
      if (!stripe) {
        this.$emit('stripe-card-error', 'Could not load stripe.js')
        return
      }

      this.$emit('set-stripe', stripe)
      const stripeElements = stripe.elements()
      const cardExpiry = stripeElements.create('cardExpiry', {
        classes: {
          focus: 'focus',
          empty: 'empty',
          invalid: 'invalid',
        },
      })
      cardExpiry.mount('#stripe-card-expiry')
      cardExpiry.on('change', this.handleCardError)
      const cardCvc = stripeElements.create('cardCvc', {
        classes: {
          focus: 'focus',
          empty: 'empty',
          invalid: 'invalid',
        },
      })
      cardCvc.mount('#stripe-card-cvc')
      cardCvc.on('change', this.handleCardError)
      const cardNumber = stripeElements.create('cardNumber', {
        showIcon: true,
        classes: {
          focus: 'focus',
          empty: 'empty',
          invalid: 'invalid',
        },
      })
      cardNumber.mount('#stripe-card-number')
      cardNumber.on('change', this.handleCardError)
      this.$emit('stripe-elements', stripeElements)
    },
    handleCardError(event: any) {
      this.$emit(
        'stripe-card-error',
        event?.error?.message ? 'Your card information is incomplete' : ''
      )
    },
  },
})
